import React, { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { FadeUp, ScaleIn } from '../components/ScrollReveal';

const VANILLA_IMG = 'https://customer-assets.emergentagent.com/job_bb23729c-0dea-4683-8280-e0aa97a36711/artifacts/rpuw479q_IMG_2753.jpeg';
const serif = { fontFamily: '"Cormorant Garamond", serif', fontStyle: 'italic', fontWeight: 400 };

const Quote = () => {
  const { lang } = useLanguage();
  const t = translations[lang].quote;
  const common = translations[lang].common;

  const [form, setForm] = useState({
    name: '',
    email: '',
    product_interest: '',
    quantity: '',
    message: '',
  });
  const [status, setStatus] = useState('idle');

  const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');

    // COPIEZ VOTRE URL GOOGLE APPS SCRIPT ICI
    const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbzw6TxVoJr5U3HwvHg5OIlYNJvCPWI5G8fHfXrMZtQMSvDiUTQPREmoSIKVKYLjDZcorA/exec";

    try {
      await fetch(SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors', // Important pour Google Scripts
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          product: form.product_interest,
          quantity: form.quantity,
          message: form.message
        }),
      });

      // Avec 'no-cors', on ne peut pas lire la réponse, donc on assume le succès
      setStatus('success');
      setForm({ name: '', email: '', product_interest: '', quantity: '', message: '' });
    } catch (error) {
      console.error("Erreur:", error);
      setStatus('error');
    }
  };

  const productOptions = [
    "Masse de cacao", "Poudre de cacao", "Beurre de cacao", "Tourteau de cacao",
    "Noix de cajou brut", "Vanille fraîche île de la Réunion",
    "Vanille givrée île de la Réunion", "Vanille sèche île de la Réunion",
    "Vanille TK noir gourmet GRADE A Madagascar", "Vanille rouge US GRADE A Madagascar",
    "Vanille Sumatra grade A Indonésie", "Vanille Tahitensis grade A Tahiti",
    "Vanille PNG grade A Papouasie-Nouvelle-Guinée", "Vanille givrée fendue d’Indonésie",
    "Vanille planifolia grade B Indonésie", "Vanille Tahitensis grade B Tahiti"
  ];

  return (
    <div className="bg-[#FAF7F2] min-h-screen">
      <section className="relative h-[45vh] flex items-end pb-12">
        <img src={VANILLA_IMG} alt="Hero" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#2C2416]/60" />
        <div className="relative z-10 container-max text-center w-full">
           <h1 className="text-5xl text-white" style={serif}>Demander un Devis</h1>
        </div>
      </section>

      <section className="py-20 container-max">
        <div className="max-w-3xl mx-auto">
          <ScaleIn>
            <div className="bg-white border border-[#E5DDD2] rounded-2xl p-8 md:p-10 shadow-sm">
              {status === 'success' ? (
                <div className="text-center py-12">
                  <CheckCircle2 size={44} className="text-[#8B4513] mx-auto mb-4" />
                  <h3 className="text-2xl mb-2" style={serif}>Merci !</h3>
                  <p className="text-[#7A6E63] text-sm">Votre demande a été enregistrée avec succès.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-5">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-[10px] uppercase tracking-widest mb-2">Nom Complet</label>
                      <input name="name" value={form.name} onChange={handleChange} required placeholder="Ex: Jean Dupont" className="input-light" />
                    </div>
                    <div>
                      <label className="block text-[10px] uppercase tracking-widest mb-2">Votre Email</label>
                      <input type="email" name="email" value={form.email} onChange={handleChange} required placeholder="Ex: contact@vanelys.fr" className="input-light" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-[10px] uppercase tracking-widest mb-2">Produit souhaité</label>
                      <select name="product_interest" value={form.product_interest} onChange={handleChange} required className="input-light">
                        <option value="">— Sélectionner —</option>
                        {productOptions.map((opt, i) => <option key={i} value={opt}>{opt}</option>)}
                      </select>
                    </div>
                    <div>
                      <label className="block text-[10px] uppercase tracking-widest mb-2">Quantité</label>
                      <input name="quantity" value={form.quantity} onChange={handleChange} required placeholder="Ex: 5 kg" className="input-light" />
                    </div>
                  </div>

                  <div>
                    <label className="block text-[10px] uppercase tracking-widest mb-2">Précisions (Optionnel)</label>
                    <textarea name="message" value={form.message} onChange={handleChange} rows="3" className="input-light" placeholder="Détails de votre demande..." />
                  </div>

                  <button type="submit" className="btn-solid w-full justify-center py-4">
                    {status === 'loading' ? "Envoi..." : "Envoyer la demande"}
                  </button>
                </form>
              )}
            </div>
          </ScaleIn>
        </div>
      </section>
    </div>
  );
};

export default Quote;